// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-box[data-v-6b48ca24]{width:20%;display:flex;flex-direction:column}.comment-box[data-v-6b48ca24]{width:80%;height:175px;padding:10px;background-color:#e5e5e5;overflow-y:scroll}.comment-box p[data-v-6b48ca24]{color:#000}.footer-container[data-v-6b48ca24]{flex-direction:column}", ""]);
// Exports
module.exports = exports;
